/**
 * 统计页面翻译映射
 * 将后端 API 返回的英文标题和描述翻译为中文
 */

// 图表标题翻译映射
export const CHART_TITLE_TRANSLATIONS: Record<string, string> = {
  // Accounts section
  'Accounts growth': '账户增长',
  'Active accounts': '活跃账户',
  'New accounts': '新账户',

  // Transactions section
  'Average transaction fee': '平均交易手续费',
  'New transactions': '新交易笔数',
  'Transactions fees': '交易手续费',
  'Transactions growth': '交易笔数增长',
  'Transactions success rate': '交易成功率',

  // Blocks section
  'Average block rewards': '平均区块奖励',
  'Average block size': '平均区块大小',
  'New blocks': '新区块',

  // Tokens section
  'New Tokens': '新资产',
  'Tokens Growth': '资产合约增长',
  'New ETH transfers': '新能量转移',

  // Gas section
  'Average gas limit': '平均能量上限',
  'AAverage gas price': '平均 Gas 价格',
  'Gas used': 'Gas 使用量',
  'Gas used growth': 'Gas 使用量增长',

  // 其他可能的标题
  'Contracts growth': '智能合约增长',
  'New contracts': '新智能合约',
  'New verified contracts': '新验证智能合约',
  'Verified contracts growth': '验证合约增长',
};

// 图表描述翻译映射
export const CHART_DESCRIPTION_TRANSLATIONS: Record<string, string> = {
  'Cumulative accounts number per period': '累计账户数',
  'Active accounts number per period': '活跃账户数',
  'New accounts number per day': '新账户数',
  'The average amount in ETH spent per transaction': '平均每笔交易手续费',
  'New transactions number': '新交易笔数',
  'Amount of tokens paid as fees': '总交易手续费',
  'Cumulative transactions number': '累计交易笔数',
  'Successful transactions rate per day': '每日交易成功率',
  'Average amount of distributed reward in tokens per day': '每日区块奖励',
  'Average size of blocks in bytes': '平均区块大小',
  'New blocks number': '新区块数',
  'New token transfers number for the period': '期间的新能量转移数',
  'Total number of tokens': '累计资产数',
  'Average gas limit per block for the period': '平均能量上限',
  'Average gas price for the period (Gwei)': '平均能量价格',
  'Cumulative gas used for the period': '能量使用量增长',
  'Cumulative number of contracts for the period': '累计智能合约数',
  'New contracts number for the period': '新智能合约数',
  'New verified contracts number for the period': '新验证智能合约数',
  'Cumulative number verified contracts for the period': '累计验证智能合约数',
};

// 分组标题翻译映射
export const SECTION_TITLE_TRANSLATIONS: Record<string, string> = {
  Accounts: '账户',
  Transactions: '交易',
  Blocks: '区块',
  Tokens: '资产',
  Gas: '能量',
  Placeholder: '占位符',
};

// 计数器标题翻译映射
export const COUNTER_TITLE_TRANSLATIONS: Record<string, string> = {
  'Total Accounts': '总账户数',
  'Total Transactions': '总交易数',
  'Total Blocks': '总区块数',
  'Total Tokens': '总代资产量',
  'Average Block Time': '平均出块时间',
  'Gas Price': 'Gas 价格',
  'Network Utilization': '网络利用率',
  'Placeholder Counter': '占位符计数器',
  'Average block time': '平均出块时间',
  'Completed txns': '完成交易数',
  'Number of deployed contracts today': '今日部署智能合约数',
  'Total accounts': '总账户数',
  'Total addresses': '总地址数',
  'Total blocks': '总区块数',
  'Total contracts': '总智能合约数',
  'Total ETH transfers': '总能量转移笔数',
  'Total tokens': '总资产数',
  'Total txns': '总交易笔数',
};

// 计数器描述翻译映射
export const COUNTER_DESCRIPTION_TRANSLATIONS: Record<string, string> = {
  'Placeholder description': '占位符描述',
};

// Units 单位翻译映射
export const UNITS_TRANSLATIONS: Record<string, string> = {
  ETH: '能量',
  eth: '能量',
};

/**
 * 翻译单位
 */
export function translateUnits(units: string | null | undefined): string | null | undefined {
  if (!units) {
    return units;
  }
  return UNITS_TRANSLATIONS[units] || units;
}

/**
 * 翻译图表标题
 */
export function translateChartTitle(title: string): string {
  return CHART_TITLE_TRANSLATIONS[title] || title;
}

/**
 * 翻译图表描述
 */
export function translateChartDescription(description: string): string {
  return CHART_DESCRIPTION_TRANSLATIONS[description] || description;
}

/**
 * 翻译分组标题
 */
export function translateSectionTitle(title: string): string {
  return SECTION_TITLE_TRANSLATIONS[title] || title;
}

/**
 * 翻译计数器标题
 */
export function translateCounterTitle(title: string): string {
  return COUNTER_TITLE_TRANSLATIONS[title] || title;
}

/**
 * 翻译计数器描述
 */
export function translateCounterDescription(description: string): string {
  return COUNTER_DESCRIPTION_TRANSLATIONS[description] || description;
}
